var map = {
	"./arrow-down-blue.svg": 1087,
	"./arrow-down-grey.svg": 1088,
	"./arrow-right-white.png": 1089,
	"./arrow-right.svg": 1090,
	"./blue-loader.svg": 1091,
	"./circle-grey.svg": 1092,
	"./circle.svg": 1093,
	"./coinbaseWalletIcon.svg": 449,
	"./discord.png": 1094,
	"./dropdown-blue.svg": 1095,
	"./dropdown.svg": 1096,
	"./dropup-blue.svg": 1097,
	"./ethereum-logo.png": 453,
	"./fortmaticIcon.png": 450,
	"./link.svg": 1098,
	"./logo/bnblogo.png": 727,
	"./logo/dailogo.png": 728,
	"./logo/ethlogo.svg": 729,
	"./logo/lrclogo.png": 730,
	"./logo/maticlogo.png": 731,
	"./logo/mcologo.png": 732,
	"./logo/metislogo.png": 733,
	"./logo/tusdlogo.png": 734,
	"./logo/usdclogo.png": 735,
	"./logo/usdtlogo.png": 736,
	"./logo/zkslogo.png": 737,
	"./magnifying-glass.svg": 1099,
	"./menu.svg": 1100,
	"./metamask.png": 671,
	"./plus-blue.svg": 1101,
	"./plus-grey.svg": 1102,
	"./portisIcon.png": 451,
	"./question-mark.svg": 1103,
	"./question.svg": 1104,
	"./spinner.svg": 1105,
	"./token-list/lists-dark.png": 672,
	"./token-list/lists-light.png": 673,
	"./trustWallet.png": 1106,
	"./twitter.png": 1107,
	"./walletConnectIcon.svg": 452,
	"./x.svg": 1108
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 572;